import "./SinglePostTemplate.module.css"
import CabecalhoInstitucional from "@/reusable_sections/Header"
import SinglePostTemplateSection from "./sections/SinglePostTemplateSection"
import InformativeFooter from "@/reusable_sections/Footer"

export default function SinglePostTemplatePage() {

  return (
    <div>
      <CabecalhoInstitucional />
      <SinglePostTemplateSection />
      <InformativeFooter />
    </div>
  )
}
